import { axiosRetry } from '@/plugins/axios';

/**
 * Fetches delivery fee information for a given venue and delivery address
 * @param {number} venueId - The venue ID
 * @param {Object} params - Query parameters for the delivery fee calculation
 * @param {string} params.origins - Origin address (venue address)
 * @param {string} params.destinations - Destination address or coordinates
 * @param {string} params.units - Distance units ('imperial' or 'metric')
 * @param {string} params.departure_time - Departure time for calculation
 * @param {boolean} params.hasAutocomplete - Whether autocomplete was used
 * @param {string} params.postCode - Delivery postcode
 * @param {string} params.country - Delivery country
 * @returns {Promise} - Axios response with delivery fee data
 */
export function getDeliveryFee(venueId, params) {
    return axiosRetry.get(`/venues/${venueId}/delivery-fee`, {
        params
    });
}
